/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Submit_DescriptionInputs */

const en_directory_promotion_submit_description = /** @type {(inputs: Directory_Promotion_Submit_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Sponsor plan is active. Submit a tool through the existing directory form; it will enter the normal editorial review queue.`)
};

const zh_directory_promotion_submit_description = /** @type {(inputs: Directory_Promotion_Submit_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的 Sponsor 套餐已激活。通过现有目录表单提交产品，提交后会进入正常的编辑审核队列。`)
};

/**
* | output |
* | --- |
* | "Your Sponsor plan is active. Submit a tool through the existing directory form; it will enter the normal editorial review queue." |
*
* @param {Directory_Promotion_Submit_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_submit_description = /** @type {((inputs?: Directory_Promotion_Submit_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Submit_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_submit_description(inputs)
	return zh_directory_promotion_submit_description(inputs)
});
export { directory_promotion_submit_description as "directory.promotion.submit_description" }